import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LanguageService } from 'src/app/services/languageService/language.service';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';
import { SwitchDialogService } from 'src/app/services/switchDialogService/switch-dialog-service';
import { UserService } from 'src/app/services/userService/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  loginGroup: FormGroup;
  forgotGroup: FormGroup;
  features = environment.features;
  hide = true;

  constructor(private formBuilder: FormBuilder, private subscriberService: SubscriberService, private userService: UserService, private languageService: LanguageService, private switchDialogService: SwitchDialogService) {
    this.loginGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}$')]],
      password: ['', Validators.required]
    });

    this.forgotGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}$')]]
    });
  }

  ngOnInit() {
    // check if there is a user in user service else redirect user - To Do
  }

  // Login to the service
  login() {
    if (!this.loginGroup.valid) {
      return;
    }
    this.subscriberService.login({
      username: this.loginGroup.controls.email.value,
      password: this.loginGroup.controls.password.value
    }).then((resp: any) => {
      if (resp && resp.success == false) {
        this.userService.getToken().then(respToken => {
          this.login();
        });
      } else {
        if (!resp.data.subscriber.onboarded) {
          this.switchDialogService.openChangePasswordDialog().subscribe(profile => {
            this.afterLogin(resp);
          });
        } else {
          this.afterLogin(resp);
        }
      }
    });
  }

  // Actions which are taking place after login
  private afterLogin(resp) {
    this.userService.setSubscriber(resp.data.subscriber);
    this.switchDialogService.openSwitchProfileDialog(this.userService);
  }

  // Login to the service as guest
  loginGuest() {
    this.subscriberService.loginGuest({
      language: this.languageService.getLanguage()
    }, this.userService).then((resp: any) => {
      this.userService.setGuestUser(resp.data.guest);
      this.userService.getLoggedInStatus.next(true);
      location.hash = "#/home";
    });
  }

  // Forgot Password action
  forgotPassword() {
    this.subscriberService.forgotPassword({ email: this.forgotGroup.controls.email.value });
  }
}